/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventCategoryLocationOverridePayload = {
    location?: EventCategoryLocationOverridePayload.location | null;
};
export namespace EventCategoryLocationOverridePayload {
    export enum location {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
}

